import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  addDistrict,
  deleteDistrict,
  getCountries,
  getDistricts,
  getStates,
  updateDistrict,
} from "../../Services/HomeService";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const ManageDistrict = () => {
  const [states, setStates] = useState([]);
  const [fetchStatesLoading, setFetchStatesLoading] = useState(false);
  const initialValues = {
    countryId: "",
    stateId: "",
    districtName: "",
  };
  const [formData, setFormData] = useState(initialValues);
  const [createDistrictLoading, setCreateDistrictLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [fetchDistrictsLoading, setFetchDistrictsLoading] = useState(false);
  const [editDistrict, setEditDistrict] = useState(initialValues);
  const [updateDistrictLoading, setUpdateDistrictLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [fetchCountriesLoading, setFetchCountriesLoading] = useState(false);

  const fetchCountries = async () => {
    try {
      setFetchCountriesLoading(true);
      const res = await getCountries();
      console.log("fetched counries", res);
      if (res?.status) {
        setCountries(res?.data);
        setFetchCountriesLoading(false);
      } else {
        toast.error("Error while Fetching Counries Data");
        setFetchCountriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Counries Data");
      console.error("Error fetching Counries:", error);
      setFetchCountriesLoading(false);
    }
  };

  const fetchStates = async (country) => {
    try {
      setFetchStatesLoading(true);
      const res = await getStates();
      console.log("fetched states", res);
      if (res?.status) {
        setStates(res?.data.filter((item) => item.country._id === country));
        setFetchStatesLoading(false);
      } else {
        toast.error("Error while Fetching States Data");
        setFetchStatesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch States Data");
      console.error("Error fetching State:", error);
      setFetchStatesLoading(false);
    }
  };
  const fetchDistricts = async () => {
    try {
      setFetchDistrictsLoading(true);
      const res = await getDistricts();
      console.log("fetched districts", res?.data);
      if (res?.status) {
        setDistricts(res?.data);
        setFetchDistrictsLoading(false);
      } else {
        toast.error("Error while Fetching Districts Data");
        setFetchDistrictsLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Districts Data");
      console.error("Error fetching Districts:", error);
      setFetchDistrictsLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
    fetchStates();
    fetchDistricts();
  }, []);

  const handleCreateDistrict = async (e) => {
    e?.preventDefault();
    if (!formData?.districtName || !formData?.stateId) {
      toast.error("Please Enter All Fields");
      return;
    }
    try {
      setCreateDistrictLoading(true);
      const res = await addDistrict(formData);
      console.log("District Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        // toast.success("State added successfully!");
        // setFormData({ districtName: "" });
        setFormData((prev) => ({ ...prev, districtName: "" }));
        fetchDistricts();
        setCreateDistrictLoading(false);
      } else {
        toast.error(res?.message);
        setCreateDistrictLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add State.");
      console.error("Error adding State:", error);
      setCreateDistrictLoading(false);
    }
  };

  const handleUpdateClick = (row) => {
    console.log("KIU122", row);

    setEditDistrict(row);
  };

  const handleCancel = () => {
    setEditDistrict(null);
  };

  const handleUpdateDistrict = async (e) => {
    e?.preventDefault();
    if (!editDistrict?.stateId || !editDistrict?.districtName) {
      toast.error("Please Enter All fields");
      return;
    }
    try {
      setUpdateDistrictLoading(true);
      const res = await updateDistrict(editDistrict?._id, {
        countryId: editDistrict?.countryId,
        stateId: editDistrict?.stateId,
        districtName: editDistrict?.districtName,
      });
      console.log("district Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        // toast.success("State added successfully!");
        fetchDistricts();
        setEditDistrict(null);
        setUpdateDistrictLoading(false);
      } else {
        toast.error(res?.message);
        setUpdateDistrictLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add State.");
      console.error("Error adding State:", error);
      setUpdateDistrictLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete District?",
      text: "Are you sure you want to delete this District?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteDistrict(id);
        Swal.fire("Deleted!", "District has been deleted.", "success");
        fetchDistricts();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete District.", "error");
      }
    }
  };

  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Country",
      selector: (row) => row.country?.countryName,
      sortable: true,
      center: true,
    },
    {
      name: "State Name",
      selector: (row) => row?.state?.stateName,
      sortable: true,
      center: true,
    },
    {
      name: "District Name",
      selector: (row) => row.districtName,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              onClick={() => {
                handleUpdateClick(row);
              }}
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          {/* <span title="Delete">
            <i
              onClick={() => {
                handleDelete(row?._id);
              }}
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span> */}
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchStates(formData?.countryId);
  }, [formData?.countryId]);
  useEffect(() => {
    fetchStates(editDistrict?.countryId);
  }, [editDistrict?.countryId]);
  return (
    <>
      {!editDistrict?._id && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Manage District
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleCreateDistrict(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      Country<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      className="form-control"
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          countryId: e?.target?.value,
                        }));
                      }}
                      value={formData?.countryId}
                    >
                      <option value="">-------- Select Country --------</option>
                      {fetchCountriesLoading ? (
                        <option>Loading...</option>
                      ) : countries?.length === 0 ? (
                        <option disabled>No Country Found</option>
                      ) : (
                        countries?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.countryName}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      State Name<span className="text-danger">*</span>
                    </label>
                    <select
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          stateId: e?.target?.value,
                        }));
                      }}
                      className="form-control"
                    >
                      <option value="">-------- Select State --------</option>
                      {fetchStatesLoading ? (
                        <option>Loading...</option>
                      ) : states?.length === 0 ? (
                        <option disabled>No States Found</option>
                      ) : (
                        states?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.stateName}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      District Name<span className="text-danger">*</span>
                    </label>
                    <input
                      value={formData?.districtName}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          districtName: e?.target?.value,
                        }));
                      }}
                      type="text"
                      id="name"
                      className="form-control"
                      // value={cityName}
                      // onChange={(e) => setCityName(e.target.value)}
                      placeholder="Enter District Name"
                      required
                    />
                  </div>
                </div>
                <div className=" d-flex justify-content-center">
                  <button
                    disabled={createDistrictLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {createDistrictLoading
                      ? "Adding District..."
                      : "Add District"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}

      {!editDistrict?._id && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <section className="chartBox_area">
              <DataTable
                data={districts}
                columns={columns}
                pagination
                responsive
                highlightOnHover
                customStyles={customStyles}
                progressPending={fetchDistrictsLoading}
              />
            </section>
          </div>
        </div>
      )}
      {editDistrict?._id && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Update District
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleUpdateDistrict(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      Country<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      className="form-control"
                      onChange={(e) => {
                        setEditDistrict((prev) => ({
                          ...prev,
                          countryId: e?.target?.value,
                        }));
                      }}
                      value={editDistrict?.countryId}
                    >
                      <option value="">-------- Select Country --------</option>
                      {fetchCountriesLoading ? (
                        <option>Loading...</option>
                      ) : countries?.length === 0 ? (
                        <option disabled>No Country Found</option>
                      ) : (
                        countries?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.countryName}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      State Name<span className="text-danger">*</span>
                    </label>
                    <select
                      value={editDistrict?.stateId}
                      onChange={(e) => {
                        setEditDistrict((prev) => ({
                          ...prev,
                          stateId: e?.target?.value,
                        }));
                      }}
                      className="form-control"
                    >
                      <option value="">-------- Select State --------</option>
                      {fetchStatesLoading ? (
                        <option>Loading...</option>
                      ) : states?.length === 0 ? (
                        <option>No States Found</option>
                      ) : (
                        states?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.stateName}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      District Name<span className="text-danger">*</span>
                    </label>
                    <input
                      value={editDistrict?.districtName}
                      onChange={(e) => {
                        setEditDistrict((prev) => ({
                          ...prev,
                          districtName: e?.target?.value,
                        }));
                      }}
                      type="text"
                      id="name"
                      className="form-control"
                      placeholder="Enter District Name"
                      required
                    />
                  </div>
                </div>
                <div
                  className=" d-flex justify-content-center"
                  style={{ gap: "15px" }}
                >
                  <button
                    disabled={updateDistrictLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {updateDistrictLoading ? "Loading..." : "Update"}
                  </button>
                  <button
                    onClick={() => {
                      handleCancel();
                    }}
                    disabled={updateDistrictLoading}
                    type="button"
                    className="btn mt-3"
                    style={{
                      background: "#f77754",
                      borderRadius: "13px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageDistrict;
